import { baseApi } from '../axios';

export const getUserStreak = async () => {
	const response = await baseApi.get(`/streak`);
	return response;
};

export const getAllBadges = async () => {
	const response = await baseApi.get(`/badge`);
	return response;
};
export const updateUserProfileImg = async ({ dp_url }: { dp_url: string }) => {
	// console.log(dp_url);
	const response = await baseApi.patch('/user-profile', dp_url);
	return response;
};
